import { CheatsheetPlayer, FantasyPosition, PlayerNextRoundAvailability } from '@pff-consumer/schema'
import { getDstName, getShortName, isPlayerDrafted } from '@pff-consumer/utils'
import type { RankingsEntity } from '../fantasy.slice'

export const getCheatsheetPlayersFromRankings = (
  players: RankingsEntity[],
  playerNextRoundAvailability: PlayerNextRoundAvailability,
  selectedSuggestedPlayerIndex: number,
  draftPickIds: string[],
  leagueKeepers: number[]
): CheatsheetPlayer[] =>
  players
    .map((player: RankingsEntity) => {
      const { id, first_name, last_name, position, bye, team, teamCity, teamName, rank, tier } = player // eslint-disable-line
      return {
        playerId: id,
        playerName:
          position === FantasyPosition.DST ? getDstName(teamCity, teamName) : getShortName(first_name, last_name), // eslint-disable-line
        position,
        bye,
        team,
        rank: rank.current as number,
        availabilityPercentage: playerNextRoundAvailability[id]
          ? playerNextRoundAvailability[id][selectedSuggestedPlayerIndex]
          : 0,
        isDrafted: isPlayerDrafted(draftPickIds, leagueKeepers, id),
        tier: tier as number,
      }
    })
    .sort((a: CheatsheetPlayer, b: CheatsheetPlayer) => a.rank - b.rank)
